export const googleCalendarTranslations = {
  // Google Calendar integration
  'googleCalendar.title': { en: 'Google Calendar', fi: 'Google-kalenteri' },
  'googleCalendar.myEvents': { en: 'My Events', fi: 'Omat tapahtumat' },
  'googleCalendar.noEvents': { en: 'No events found', fi: 'Tapahtumia ei löytynyt' },
  'googleCalendar.loading': { en: 'Loading events...', fi: 'Ladataan tapahtumia...' },
  'googleCalendar.error': { en: 'Error loading Google Calendar data', fi: 'Virhe kalenteridatan lataamisessa' },
  'googleCalendar.notConnected': { en: 'Google Calendar not connected', fi: 'Google-kalenteria ei ole yhdistetty' },
  'googleCalendar.connectHint': { en: 'Sign in with Google to connect your calendar', fi: 'Kirjaudu sisään Googlella yhdistääksesi kalenterisi' },
  'googleCalendar.refresh': { en: 'Refresh', fi: 'Päivitä' },
  'googleCalendar.allDay': { en: 'All day', fi: 'Koko päivä' },
  'googleCalendar.attendees': { en: 'attendees', fi: 'osallistujaa' },
  'googleCalendar.noTitle': { en: '(No title)', fi: '(Ei otsikkoa)' },
  'googleCalendar.analyzing': { en: 'Analyzing event...', fi: 'Analysoidaan tapahtumaa...' },
};
